import React, { useEffect, useState } from "react";
import AddressCard from "../../components/addressCard";
import CustomButton from "../../../../component/elements/CustomButton/CustomButton";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { useSelector } from "react-redux";
import CustomPopupForm from "../../../../component/customPopupModel";
import { FaPlus } from "react-icons/fa";
import { Player } from "@lottiefiles/react-lottie-player";
import notFound from "../../../../assets/animation/notFount.json";

const DIALOG_TYPES = {
  CREATE: "address",
  DELETE: "delete",
};

export default function Addresses() {
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const userId = loginDetails.userId || null;
  const [addresses, setAddresses] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const [mode, setMode] = useState("create");
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [initialAddressArray, setInitialAddressArray] = useState([]);
  useEffect(() => {
    fetchUser();
  }, []);

  const fetchUser = () => {
    axiosInstance
      .get(`/customer/users?id=${userId}`)
      .then((res) => {
        let data = res?.data?.data[0]?.addresses;
        const formattedAddress = data?.map((item) => ({
          id: item?.id,
          is_primary: item?.is_primary,
          address_type: item?.address_type ? item?.address_type : "Other",
          addressLine:
            `${item.house_no || ""} ${item.landmark || ""} ${item.city || ""} ${
              item.state || ""
            } ${item.zipcode || ""}` || "",
          address: item,
        }));
        setInitialAddressArray(data);
        setAddresses(formattedAddress);
      })
      .catch((err) => showSnackbar("Something went wrong!", "error"));
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedAddress(null);
    setDialogType("");
  };

  const handleAddAddress = () => {
    setMode("create");
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleEdit = (data) => {
    setMode("edit");
    setSelectedAddress(data.address);
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleDelete = (data) => {
    setSelectedAddress(data);
    setDialogType(DIALOG_TYPES.DELETE);
    setOpenDialog(true);
  };

  const handleDeleteConfirm = async (id) => {
    axiosInstance
      .delete(`/customer/users/address/delete/${id}`)
      .then((res) => {
        handleCloseDialog();
        showSnackbar("Your address deleted successfully");
        fetchUser();
      })
      .catch((err) => showSnackbar("Something went wrong!", "error"));
  };

  const handleSubmit = async (formData) => {
    let updatedArray = [];

    if (mode === "edit") {
      updatedArray = initialAddressArray.map((item) =>
        item.id === formData.id ? formData : item
      );
    } else if (mode === "create") {
      updatedArray = [...initialAddressArray, formData];
    }

    updatAddress(
      updatedArray,
      mode === "edit"
        ? "Your address updated successfully"
        : "Your address created successfully"
    );
  };

  const handleSetDefault = async (isChecked, id) => {
    const updatedArray = initialAddressArray.map((item) => ({
      ...item,
      is_primary: item.id === id ? isChecked : false,
    }));
    updatAddress(updatedArray, "Your primary address updated successfully");
  };

  const updatAddress = (data, message) => {
    let payload = {
      addresses: data,
    };
    axiosInstance
      .patch(`/customer/users/${userId}`, payload)
      .then((res) => {
        handleCloseDialog();
        showSnackbar(message);
        fetchUser();
      })
      .catch((err) => showSnackbar("Something went wrong!", "error"));
  };

  return (
    <div className="w-full ">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-[600] mb-3">
          Manage <span className="text-[#008ECC]">Addresses</span>
        </h2>
        <CustomButton
          onClick={() => handleAddAddress()}
          customeClass="customer-dark-button w-[200px] h-[35px]"
        >
          <FaPlus className="text-base mr-2" />
          Add new Address
        </CustomButton>
      </div>
      {addresses.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {addresses.map((item) => (
            <AddressCard
              key={item.id}
              addressLabel={item.address_type}
              addressData={item}
              onEdit={() => handleEdit(item)}
              onDelete={() => handleDelete(item)}
              onSetDefault={(e) => handleSetDefault(e, item.id)}
            />
          ))}
        </div>
      ) : (
        <div className="flex flex-col bg-white items-center justify-center py-10 text-gray-500">
          <Player
            autoplay
            loop
            src={notFound}
            style={{ height: "200px", width: "200px" }}
          />
          <p className="text-center text-sm md:text-base">No orders found</p>
        </div>
      )}

      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          mode={mode}
          dialogDetails={selectedAddress}
          onSubmit={handleSubmit}
        />
      )}

      {dialogType === DIALOG_TYPES.DELETE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.DELETE}
          onDelete={handleDeleteConfirm}
          dialogDetails={{
            title: "Delete Confirmation",
            content: "Are you sure you want to delete this address?",
            rowData: selectedAddress,
          }}
        />
      )}
    </div>
  );
}
